import { IconButton } from "@mui/material";

import styled from "styled-components";

export const Button = styled(IconButton)`
  width: 36px;
  height: 36px;

  background: rgba(235, 194, 142, 0.2);
  border: 1px solid rgba(235, 194, 142, 0.3);
  border-radius: 50%;

  transition: all 0.3s ease;

  path {
    fill: #fff;
  }

  &:hover {
    background: rgba(235, 194, 142, 0.35);
    border-color: rgba(235, 194, 142, 0.5);
  }
`;
